'use strict';

angular.module('ClinicApp').directive('expandableItem', function() {
  return {
    templateUrl: '/views/directives/_expandable-item.html',
    transclude: true,
    scope: {
      title: '@',
      startExpanded: '@',
    },
    link: function($scope) {
      $scope.collapsed = !$scope.startExpanded;

      $scope.toggle = function() {
        $scope.collapsed = !$scope.collapsed;
      };
    },
  };
});
